export const AnalyticsEvents = {
  // Auth
  AUTH_LOGIN_STARTED: 'auth_login_started',
  AUTH_LOGIN_SUCCESS: 'auth_login_success',
  AUTH_LOGOUT: 'auth_logout',

  // Onboarding
  ONBOARDING_COMPLETED: 'onboarding_completed',
  ONBOARDING_SKIPPED: 'onboarding_skipped',

  // Profile
  PROFILE_UPDATED: 'profile_updated',

  // AI Chat
  AI_CHAT_OPENED: 'ai_chat_opened',
  AI_CHAT_MESSAGE_SENT: 'ai_chat_message_sent',
  AI_CHAT_CONVERSATION_CREATED: 'ai_chat_conversation_created',

  // Feed / Insights
  INSIGHT_CREATED: 'insight_created',
  INSIGHT_TRACKED: 'insight_tracked',
  INSIGHT_UNTRACKED: 'insight_untracked',
  INSIGHT_UPDATED: 'insight_updated',
  INSIGHT_DELETED: 'insight_deleted',
  FEED_SEARCHED: 'feed_searched',
  FEED_FILTERED: 'feed_filtered',

  // Portfolio / Positions
  POSITION_CREATED: 'position_created',
  POSITION_UPDATED: 'position_updated',
  POSITION_DELETED: 'position_deleted',

  // SMS
  SMS_SUBSCRIBED: 'sms_subscribed',
  SMS_UNSUBSCRIBED: 'sms_unsubscribed',

  // Admin — SMS Broadcast
  ADMIN_SMS_BROADCAST_SENT: 'admin_sms_broadcast_sent',

  // Admin — User Management
  ADMIN_USER_APPROVED: 'admin_user_approved',
  ADMIN_USER_REVOKED: 'admin_user_revoked',

  // Admin — Document Management
  ADMIN_DOCUMENT_UPLOADED: 'admin_document_uploaded',
  ADMIN_DOCUMENT_DELETED: 'admin_document_deleted',

  // Admin — Exemplar Management
  ADMIN_EXEMPLAR_CREATED: 'admin_exemplar_created',
  ADMIN_EXEMPLAR_DELETED: 'admin_exemplar_deleted',
  ADMIN_EXEMPLAR_BULK_IMPORTED: 'admin_exemplar_bulk_imported',

  // Landing page
  LANDING_VIEWED: 'landing_viewed',
  LANDING_APPLY_CLICKED: 'landing_apply_clicked',
  LANDING_SIGNIN_CLICKED: 'landing_signin_clicked',
} as const
